import { render, staticRenderFns } from "./PreloadAdyenBuyPremium.vue?vue&type=template&id=7a8af1c7&scoped=true&"
import script from "./PreloadAdyenBuyPremium.vue?vue&type=script&lang=js&"
export * from "./PreloadAdyenBuyPremium.vue?vue&type=script&lang=js&"
import style0 from "./PreloadAdyenBuyPremium.vue?vue&type=style&index=0&id=7a8af1c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8af1c7",
  null
  
)

export default component.exports